import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled, th } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';

import { withSettings } from 'containers/WebApp/SettingsContext';

import FooterLogo from '../../../theme/logo-polyaire.svg';

const FooterWrapper = styled.footer`
  background-color: ${th('grey')};
  color: #141a1a;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 2rem 0 1rem 0;

  .footer-logo {
    width: 190px;
    height: auto;
    margin: 0 auto;
  }

  p {
    color: #464845;
    font-size: 16px;
  }
  ul {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${up(
      'md',
      css`
        flex-direction: row;
      `
    )};
  }
  li {
    font-size: 16px;
    text-align: center;
    padding: 5px 0;
    ${up(
      'md',
      css`
        padding: inherit;
        text-align: left;
        &:nth-last-child(1) {
          border-right: none;
        }
      `
    )};
    a {
      color: #464845;
      text-decoration: underline;
      padding: 0.1rem 1rem;
      &:hover,
      &:focus {
        text-decoration: none;
      }
    }
  }

  .footer-right-text {
    padding: 0 1rem;
  }
`;

const Footer = ({ siteName }) => (
  <FooterWrapper>
    <FooterContainer>
      <img src={FooterLogo} alt="Polyaire" className="footer-logo" />
      <ul>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/faqs">FAQs</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>
        <li>
          <Link to="/terms">Terms & Conditions</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy Policy</Link>
        </li>
      </ul>
      <p className="text--center footer-right-text">
        &copy; {new Date().getFullYear()} Polyaire Reward Zone
      </p>
    </FooterContainer>
  </FooterWrapper>
);

Footer.propTypes = {
  siteName: PropTypes.string,
};

Footer.defaultProps = {
  siteName: 'Lori Program Default',
};

export default withSettings(Footer);
